import { render } from "./PaymentOrder.vue?vue&type=template&id=48d90859&scoped=true"
import script from "./PaymentOrder.vue?vue&type=script&lang=js"
export * from "./PaymentOrder.vue?vue&type=script&lang=js"

import "./PaymentOrder.vue?vue&type=style&index=0&id=48d90859&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d90859"]])

export default __exports__